// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FqcX","textarea":"styles_textarea__2vtef"};